/* hs-eslint ignored failing-rules */
/* eslint-disable no-prototype-builtins */

'use es6';

import ContentRoutes from 'ContentUtils/Routes';
import DesignAssetTypes from 'ContentUtils/constants/DesignAssetTypes';
import { isV1GlobalModule } from 'ContentEditorUI/data/moduleUtils';
import PaddingConstants from 'EmailEditorUI/constants/PaddingConstants';
import { constrainImageDimensionsToMaxWidth } from 'ContentEditorUI/utils/imageUtils';
import { object } from 'underscore';
import { fromJS, List } from 'immutable';
import { createSelector } from 'reselect';
import { getScopes } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getHasCustomFooters, getHasCoreContentAccess, getHasFullEditorAccess } from 'EmailEditorUI/redux/selectors/AuthSelectors';
import { MODULES, MODULE_TYPES, getModuleType, getLegacyModuleType, getModuleId } from 'EmailData/constants/DefaultModulesConstants';
import { RICH_TEXT_TYPES } from 'ContentEditorUI/lib/inpage/Constants';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
import { BUILTIN_FOOTER, BUILTIN_WEBVERSION } from 'EmailEditorUI/constants/SidebarConstants';
import { MODULE_PADDING_FLAG_KEY, MODULE_PADDING_CSS_KEY } from 'EmailEditorUI/utils/dragDropModuleConstants';
import { FAKE_MODULES_NAMES } from 'ContentEditorUI/constants/FakeModulesConstants';
import I18n from 'I18n';
import { memoize } from 'underscore';
import { getImmutableOrPlain } from 'ContentEditorUI/utils/dataHelpers';
import { CONTENT, STYLE } from 'ContentUtils/constants/CustomWidgetFieldGroupTabTypes';
import { CartIcon } from 'foundations-assets/icons/components/CartIcon';
import { CreditCardIcon } from 'foundations-assets/icons/components/CreditCardIcon';
import { CtasIcon } from 'foundations-assets/icons/components/CtasIcon';
import { FooterIcon } from 'foundations-assets/icons/components/FooterIcon';
import { ProductIcon } from 'foundations-assets/icons/components/ProductIcon';
import { UNSUBSCRIBE_ACTION_SPECIFIC, UNSUBSCRIBE_ACTION_ALL, UNSUBSCRIBE_LINK_TOKEN_SPECIFIC, UNSUBSCRIBE_LINK_TOKEN_ALL, PREFERENCES_LINK_TYPE, SUBSCRIPTION_LINK_TO, BUTTON_SUBSCRIPTION_TYPE_UNSUBSCRIBE, FOOTER_TYPE_DEFAULT } from 'EmailEditorUI/utils/fieldNamesConstants';
export const MAX_SAFE_INTEGER = 9007199254740991;
const {
  BUTTON,
  IMAGE,
  RICH_TEXT,
  FOOTER,
  DIVIDER,
  FOLLOW_ME,
  BLOG_RSS,
  WEB_VERSION_LINK,
  EMAIL_VIEW_AS_WEB_PAGE,
  HTML,
  EMAIL_PRODUCTS,
  EMAIL_ABANDONED_CART,
  EMAIL_VIDEO,
  EMAIL_CAN_SPAM,
  EMAIL_SURVEY,
  EMAIL_BODY,
  EMAIL_CART
} = MODULE_TYPES;
export const INLINE_TYPES = ['rich_text', 'email_resubscribe', 'email_optin', 'email_body'];
const CORE_MODULES = [BUTTON, IMAGE, RICH_TEXT, FOOTER, DIVIDER, FOLLOW_ME, EMAIL_VIDEO, EMAIL_PRODUCTS];
export const NEW_MODULES = [];
export const BETA_MODULES = [EMAIL_CART];
export const INLINE_MODULES = [RICH_TEXT];
export const NON_EDITABLE_MODULES = [];
export const NON_SMART_ENABLED_MODULES = [BLOG_RSS, FOOTER, WEB_VERSION_LINK, EMAIL_VIEW_AS_WEB_PAGE, EMAIL_CAN_SPAM];

// When true used to block publish / show upgrade points / block editing
export const SCOPED_MODULES = {
  [EMAIL_PRODUCTS]: state => !getHasFullEditorAccess(state),
  [EMAIL_CART]: state => !getHasFullEditorAccess(state)
};
export const MODULES_WITH_AUTH = {
  [HTML]: getHasCoreContentAccess,
  [WEB_VERSION_LINK]: getHasCoreContentAccess,
  [FOOTER]: getHasCustomFooters
};
export const MODULE_ICON_OVERRIDES = {
  [BUTTON]: {
    isIcon: true,
    ModuleIcon: CtasIcon
  },
  [FAKE_MODULES_NAMES.PAYMENTS]: {
    isIcon: true,
    ModuleIcon: CreditCardIcon
  },
  [FOOTER]: {
    isIcon: true,
    ModuleIcon: FooterIcon
  },
  [EMAIL_PRODUCTS]: {
    isIcon: true,
    ModuleIcon: ProductIcon
  },
  [EMAIL_CART]: {
    isIcon: true,
    ModuleIcon: CartIcon
  }
};
const DYNAMIC_DATA_HS_CLASS = '_hs_using_dynamic_data';
const FAKE_PLACEHOLDER_DATA_HS_CLASS = '_hs_using_fake_placeholder_data';
export const getIsNewModule = moduleId => {
  const type = getModuleType(moduleId);
  if (type) {
    return NEW_MODULES.includes(type);
  }
  return null;
};
export const getIsBetaModule = moduleId => {
  const type = getModuleType(moduleId);
  if (type) {
    return BETA_MODULES.includes(type);
  }
  return null;
};
export const getUpgradeModalForModuleType = moduleType => {
  switch (moduleType) {
    case MODULE_TYPES.EMAIL_PRODUCTS:
      return MODAL_TYPES.PRODUCTS_MODULE_PQL;
    case MODULE_TYPES.EMAIL_CART:
      return MODAL_TYPES.CART_MODULE_PQL;
    default:
      return null;
  }
};
export const getIconOverride = (moduleId, moduleLabel = false) => {
  const type = getModuleType(moduleId);
  if (moduleLabel && moduleLabel.toLowerCase() === FAKE_MODULES_NAMES.PAYMENTS) {
    return MODULE_ICON_OVERRIDES[FAKE_MODULES_NAMES.PAYMENTS];
  }
  if (type) {
    return MODULE_ICON_OVERRIDES[type];
  }
  return null;
};
export const CLIENT_RENDERED_MODULES = [RICH_TEXT];
export const MAX_COLUMN_WIDTH = 12;
export const MIN_COLUMN_PIXEL_WIDTH = 120;
export const MAX_EMAIL_WIDTH = 600;
export const MODULES_WITH_MAX_WIDTH = [IMAGE, BLOG_RSS, EMAIL_VIDEO, EMAIL_PRODUCTS];
export const EMPTY_PADDING_CONFIG = {
  top: PaddingConstants.NONE,
  right: PaddingConstants.NONE,
  bottom: PaddingConstants.NONE,
  left: PaddingConstants.NONE
};
export function getPaddingCss(paddingOn) {
  return paddingOn ? fromJS({
    'padding-left': '20px',
    'padding-right': '20px',
    'padding-top': '10px',
    'padding-bottom': '10px'
  }) : fromJS({});
}
export function getIsPaddingEnabledFromCSS(value) {
  return !value.isEmpty() && !!value.findEntry(v => v !== '0px');
}
export function findColumnContainingElement(element, sections) {
  const containingSection = sections.find(section => section.get('columns').find(column => column.get('widgets').indexOf(element.get('id')) > -1));
  if (!containingSection) {
    return null;
  }
  return containingSection.get('columns').find(column => column.get('widgets').indexOf(element.get('id')) > -1);
}

// Handle an issue where images uploaded through the file manager
// end up with the width value unset by defaulting to the max width
export function ensureImageWidthExists(imageData, maxWidth) {
  if (imageData && 'width' in imageData && !imageData.width) {
    return Object.assign({}, imageData, {
      width: maxWidth
    });
  }
  return imageData;
}
export function moduleSpecHasField(moduleSpec, fieldName) {
  return !!moduleSpec.fields.find(f => f.name === fieldName);
}
const SERIALIZED_RSS_PROP_NAMES = {
  rssUrl: 'rss_url',
  maxRssEntries: 'max_rss_entries',
  rssEmailImageMaxWidth: 'rss_email_image_max_width',
  rssEmailBlogImageMaxWidth: 'rss_email_blog_image_max_width',
  rssEmailEntryTemplate: 'rss_email_entry_template',
  rssEmailAuthorLineTemplate: 'rss_email_author_line_template',
  blogRssSettings: 'blog_rss_settings',
  rssEmailEntryTemplateEnabled: 'rss_email_entry_template_enabled',
  rssToEmailTiming: 'rss_to_email_timing'
};
export const serializeRssProperties = props => Object.keys(props).reduce((acc, key) => {
  const splitted = key.split('-');
  let value = props[key];
  if (splitted.length > 1) {
    key = splitted[0];
    value = {
      [splitted[1]]: value
    };
  }
  const serializedKey = SERIALIZED_RSS_PROP_NAMES[key];
  if (acc[serializedKey]) {
    acc[serializedKey] = Object.assign({}, acc[serializedKey], value);
  } else {
    acc[serializedKey] = value;
  }
  return acc;
}, {});
export const getModuleIds = types => List(types.map(getModuleId));
const getAuthedModuleTypes = (types, modulePermissions) => {
  return types.filter(type => modulePermissions.hasOwnProperty(type) ? modulePermissions[type] : true);
};
export const getAuthedModuleIds = (types, modulePermissions) => {
  const authedKeys = getAuthedModuleTypes(types, modulePermissions);
  return getModuleIds(authedKeys);
};

/**
 * Checks module IDs contained within the `WIDGET_IDS_TO_ALWAYS_RENDER_WITH_V3` config.
 */
export const getWidgetIdsToAlwaysRenderWithV3 = () => getModuleIds([EMAIL_CART]);
const modulePermissionKeys = Object.keys(MODULES_WITH_AUTH || {});
const modulePermissionSelectors = Object.values(MODULES_WITH_AUTH || {});
const getModulePermissions = createSelector(modulePermissionSelectors, (...permissions) => object(modulePermissionKeys, permissions));
const scopedModulesKeys = Object.keys(SCOPED_MODULES || {});
const scopedModulesSelectors = Object.values(SCOPED_MODULES || {});
const getScopedModules = createSelector(scopedModulesSelectors, (...scopedModules) => object(scopedModulesKeys, scopedModules));
export const getScopedModuleIds = createSelector([getScopedModules], scopedModules => {
  const scopedKeys = getAuthedModuleTypes(scopedModulesKeys, scopedModules);
  return getModuleIds(scopedKeys);
});
export const getScopedModulesTypes = createSelector([getScopedModules], scopedModules => getAuthedModuleTypes(scopedModulesKeys, scopedModules));
const createModuleIdSelector = keys => createSelector(() => true, () => getModuleIds(keys));
const createAuthedModuleIdSelector = types => createSelector([getModulePermissions], modulePermissions => getAuthedModuleIds(types, modulePermissions));
export const getDefaultModuleIds = createModuleIdSelector(Object.keys(MODULES));
export const getIsModuleDefault = element => {
  if (!element) {
    return false;
  }
  if (typeof element.get === 'function') {
    return Boolean(getModuleType(element.get('module_id')) || getLegacyModuleType(element.get('type')));
  }
  return Boolean(getModuleType(element.moduleId) || getLegacyModuleType(element.type));
};
export const getAuthedDefaultModuleIds = createAuthedModuleIdSelector(Object.keys(MODULES));
export const getDisplayOrderDefaultModuleIds = createAuthedModuleIdSelector([IMAGE, RICH_TEXT, BUTTON, DIVIDER, FOLLOW_ME, EMAIL_VIDEO, FOOTER, EMAIL_PRODUCTS, EMAIL_CART, HTML]);
export const getCoreModuleIds = createModuleIdSelector(CORE_MODULES);
export const getInlineModuleIds = createModuleIdSelector(INLINE_MODULES);
export const getNonEditableModuleIds = createModuleIdSelector(NON_EDITABLE_MODULES);
export const getModuleIdsNotEnabledForSmartContent = createModuleIdSelector(NON_SMART_ENABLED_MODULES);
const SCOPED_MODULES_FOR_DELIVERY = {
  [BLOG_RSS]: 'email-batch-rss-blog'
};
export const getExpectedDefaultModuleIdsForScopes = createSelector([getScopes, getCoreModuleIds], (scopes, coreModuleIds) => {
  return Object.keys(SCOPED_MODULES_FOR_DELIVERY).reduce((expected, key) => {
    if (scopes.includes(SCOPED_MODULES_FOR_DELIVERY[key])) {
      return expected.push(getModuleId(key));
    }
    return expected;
  }, coreModuleIds);
});
const createIdChecker = moduleTypes => moduleId => Array.isArray(moduleTypes) ? moduleTypes.includes(getModuleType(moduleId)) : moduleTypes === getModuleType(moduleId);
const createModuleTypeFunc = func => element => func(getImmutableOrPlain(element, 'module_id'));
export const isRichTextId = createIdChecker(RICH_TEXT);
export const isDividerId = createIdChecker(DIVIDER);
export const isImageId = createIdChecker(IMAGE);
export const isVideoId = createIdChecker(EMAIL_VIDEO);
export const isWebversionId = createIdChecker([WEB_VERSION_LINK, EMAIL_VIEW_AS_WEB_PAGE]);
export const isFooterId = createIdChecker([FOOTER, EMAIL_CAN_SPAM]);
export const isLegacyFooterId = createIdChecker(EMAIL_CAN_SPAM);
export const isEmailSurveyModuleId = createIdChecker(EMAIL_SURVEY);
export const isButtonId = createIdChecker(BUTTON);
export const isFollowMeModule = createIdChecker(FOLLOW_ME);
export const isBlogRssModule = createIdChecker(BLOG_RSS);
export const getIsImageModule = createModuleTypeFunc(isImageId);
export const getIsVideoModule = createModuleTypeFunc(isVideoId);
export const getIsButtonModule = createModuleTypeFunc(isButtonId);
export const getIsPaymentsModule = module => {
  var _module$get;
  return (module === null || module === void 0 || (_module$get = module.get('body')) === null || _module$get === void 0 ? void 0 : _module$get.get('link_to')) === 'payments';
};
const _getIsWebVersionModule = createModuleTypeFunc(isWebversionId);
const _getIsFooterModule = createModuleTypeFunc(isFooterId);
export const getIsBuiltInFooterModule = module => (module === null || module === void 0 ? void 0 : module.get('_isBuiltIn')) && module.get('type') === BUILTIN_FOOTER;
export const getIsBuiltInWebVersionModule = module => (module === null || module === void 0 ? void 0 : module.get('_isBuiltIn')) && module.get('type') === BUILTIN_WEBVERSION;
export const getIsFooterModule = module => _getIsFooterModule(module) || getIsBuiltInFooterModule(module);
export const getIsWebVersionModule = module => _getIsWebVersionModule(module) || getIsBuiltInWebVersionModule(module);
export const getIsBuiltInModuleType = module => getIsBuiltInWebVersionModule(module) || getIsBuiltInFooterModule(module);
export const getIsEmailSurveyModule = createModuleTypeFunc(isEmailSurveyModuleId);
const _getIsRichTextModule = createModuleTypeFunc(isRichTextId);
export const getIsRichTextModule = element => _getIsRichTextModule(element) || RICH_TEXT_TYPES.includes(element.get('type'));
export const getIsFollowMeModule = createModuleTypeFunc(isFollowMeModule);
export const getIsBlogRssModule = createModuleTypeFunc(isBlogRssModule);
const _getIsEmailBodyModule = createModuleTypeFunc(createIdChecker(EMAIL_BODY));
export const getIsEmailBodyModule = module => module.get('type') === 'rich_text' && module.get('id') === 'hs_email_body' || _getIsEmailBodyModule(module);
export const getIsSingleLineOfTextModule = element => element.get('type') === 'text';
export const isEmailEcommModule = createIdChecker([EMAIL_PRODUCTS, EMAIL_ABANDONED_CART, EMAIL_CART]);
export const getIsEmailEcommModule = createModuleTypeFunc(isEmailEcommModule);
export const isEmailProductModule = createIdChecker([MODULE_TYPES.EMAIL_PRODUCTS]);
export const isEmailAbandonedCartModule = createIdChecker([MODULE_TYPES.EMAIL_ABANDONED_CART]);
export const isEmailCartModule = createIdChecker([MODULE_TYPES.EMAIL_CART]);
export const getIsEmailProductModule = createModuleTypeFunc(isEmailProductModule);
export const getIsEmailAbandonedCartModule = createModuleTypeFunc(isEmailAbandonedCartModule);
export const getIsEmailCartModule = createModuleTypeFunc(isEmailCartModule);
export const moduleDefaultsKeysByType = {
  [BUTTON]: 'button_email',
  [DIVIDER]: 'email_divider',
  [RICH_TEXT]: 'rich_text',
  [FOLLOW_ME]: 'follow_me',
  [EMAIL_PRODUCTS]: 'email_products',
  [EMAIL_ABANDONED_CART]: 'email_abandoned_cart',
  [EMAIL_CART]: 'email_cart'
};
export const getModuleDefaultsKeyByType = moduleType => {
  return moduleDefaultsKeysByType[moduleType];
};
export const createNetwork = (network, socialNetworks = []) => {
  const connectedNetworks = socialNetworks.filter(nw => nw.accountType === network);
  const followMeNetwork = connectedNetworks.find(nw => nw.followMe) || connectedNetworks[0];
  return {
    network,
    network_image: null,
    url: followMeNetwork ? followMeNetwork.profileUrl : null
  };
};
export function getDefaultForFieldFromModuleSpec(moduleSpec, fieldName) {
  var _moduleSpec$fields;
  const field = moduleSpec === null || moduleSpec === void 0 || (_moduleSpec$fields = moduleSpec.fields) === null || _moduleSpec$fields === void 0 ? void 0 : _moduleSpec$fields.find(f => f.name === fieldName);
  if (field) {
    return field.default;
  }
  return null;
}
export const isGlobalModule = (module, moduleSpec, isBuiltin = false) => {
  return !isBuiltin && module.get('type') === 'global_widget' || moduleSpec && moduleSpec.global;
};
export const getSelectedSmartRuleBody = element => {
  const selectedSmartRuleId = element.get('selectedSmartRuleId');
  if (!selectedSmartRuleId) {
    return element.get('body');
  }
  const selectedSmartRule = element.get('smart_objects').find(smartRule => smartRule.get('criterion_id') === selectedSmartRuleId);
  let smartRuleObject = selectedSmartRule ? selectedSmartRule.get('body') : element.get('body');
  smartRuleObject = smartRuleObject.set('hs_wrapper_css', element.get('body').get('hs_wrapper_css'));
  return smartRuleObject;
};
const getModuleDefault = (moduleSpec, fieldName) => {
  const defaults = moduleSpec.fields.filter(field => field.name === fieldName);
  if (defaults.length) {
    return fromJS(defaults[0].default);
  }
  return null;
};
export const getElementFieldValue = (element, fieldName, moduleSpec = null) => getSelectedSmartRuleBody(element).get(fieldName) || moduleSpec && getModuleDefault(moduleSpec, fieldName);
export const getPaddingConfig = (element, isFullWidthEmail) => {
  let css = getElementFieldValue(element, MODULE_PADDING_CSS_KEY);
  if (!css) {
    let paddingEnabled = element.getIn(['body', MODULE_PADDING_FLAG_KEY]);
    if (paddingEnabled == null) {
      paddingEnabled = !isFullWidthEmail;
    }
    css = getPaddingCss(paddingEnabled);
  }
  // Padding will have been applied in backend so no need to wrap it here
  if (css.isEmpty()) {
    return EMPTY_PADDING_CONFIG;
  }
  return {
    top: Number(css.get('padding-top').replace('px', '')),
    right: Number(css.get('padding-right').replace('px', '')),
    bottom: Number(css.get('padding-bottom').replace('px', '')),
    left: Number(css.get('padding-left').replace('px', ''))
  };
};
export function determineMaxWidthOfElement(element, sections, hasNoMaxWidth = false, bodyBorderWidth = 0) {
  if (hasNoMaxWidth) {
    return MAX_SAFE_INTEGER;
  }
  if (!element) {
    return 0;
  }
  const column = findColumnContainingElement(element, sections);
  if (!column) {
    return 0;
  }
  const paddingConfig = getPaddingConfig(element, hasNoMaxWidth);
  const actualEmailWidth = MAX_EMAIL_WIDTH - bodyBorderWidth * 2;
  const columnWidth = actualEmailWidth / (MAX_COLUMN_WIDTH / column.get('width'));
  return Math.floor(columnWidth - (paddingConfig.left + paddingConfig.right));
}
export function constrainVideoDimensions(element, sections, hasNoMaxWidth = false, bodyBorderWidth = 0) {
  if (!element.getIn(['body', 'img']) || hasNoMaxWidth) {
    return element;
  }
  const {
    width,
    height
  } = element.getIn(['body', 'img']).toJSON();
  const maxWidth = determineMaxWidthOfElement(element, sections, false, bodyBorderWidth);
  const {
    width: newWidth,
    height: newHeight
  } = constrainImageDimensionsToMaxWidth({
    maxWidth,
    width,
    height
  });
  return element.mergeIn(['body', 'img'], {
    width: newWidth,
    height: newHeight
  });
}
export function constrainImageDimensions(element, sections, hasNoMaxWidth = false, bodyBorderWidth = 0) {
  if (!element.getIn(['body', 'img']) || hasNoMaxWidth) {
    return element;
  }
  const {
    width,
    height
  } = element.getIn(['body', 'img']).toJSON();
  const maxWidth = determineMaxWidthOfElement(element, sections, false, bodyBorderWidth);
  const {
    width: newWidth,
    height: newHeight
  } = constrainImageDimensionsToMaxWidth({
    maxWidth,
    width,
    height
  });
  return element.mergeIn(['body', 'img'], {
    width: newWidth,
    height: newHeight
  });
}
export const isUsingDynamicData = (element, renderedOutput) => {
  var _renderedOutput$html;
  return element && isEmailProductModule(element.get('module_id')) && (renderedOutput === null || renderedOutput === void 0 || (_renderedOutput$html = renderedOutput.html) === null || _renderedOutput$html === void 0 ? void 0 : _renderedOutput$html.includes(DYNAMIC_DATA_HS_CLASS));
};
export const isUsingFakePlaceholderData = (element, renderedOutput) => {
  var _renderedOutput$html2;
  return element && isEmailProductModule(element.get('module_id')) && (renderedOutput === null || renderedOutput === void 0 || (_renderedOutput$html2 = renderedOutput.html) === null || _renderedOutput$html2 === void 0 ? void 0 : _renderedOutput$html2.includes(FAKE_PLACEHOLDER_DATA_HS_CLASS));
};
export const getPaymentsModuleSpecs = memoize(moduleSpec => {
  const paymentsModuleSpec = Object.assign({}, moduleSpec);
  const linkToField = paymentsModuleSpec.fields.find(f => f.name === 'link_to');
  const textField = paymentsModuleSpec.fields.find(f => f.name === 'text');
  linkToField.default = 'payments';
  textField.default = I18n.text('layoutBuilder.placeholders.payments.defaultButtonText');
  paymentsModuleSpec.name = 'Payments';
  return paymentsModuleSpec;
});
export function getModuleTabForFieldPath(fieldPath, moduleSpec) {
  if (Array.isArray(moduleSpec.fields) && Array.isArray(fieldPath)) {
    const field = moduleSpec.fields.find(({
      name
    }) => name === fieldPath[0]);
    if ((field === null || field === void 0 ? void 0 : field.tab) === STYLE) {
      return STYLE;
    }
  }
  return CONTENT;
}
export function getCustomWidgetDesignManagerUrl(moduleSchemaId, element) {
  return ContentRoutes.designManager(moduleSchemaId, isV1GlobalModule(element) ? DesignAssetTypes.GLOBAL_WIDGET : DesignAssetTypes.CUSTOM_WIDGET);
}
export const getRecommendedModuleIDs = createAuthedModuleIdSelector([IMAGE, RICH_TEXT, BUTTON]);
export const hasNoFieldsInContentTab = moduleSpec => {
  var _moduleSpec$fields2;
  const contentTabFields = ((_moduleSpec$fields2 = moduleSpec.fields) === null || _moduleSpec$fields2 === void 0 ? void 0 : _moduleSpec$fields2.filter(field => !field.tab || field.tab === CONTENT).filter(field => field.name !== MODULE_PADDING_FLAG_KEY)) || [];
  return contentTabFields.length === 0;
};
const getModuleHtmlContent = module => {
  return module.getIn(['body', 'html']) || module.getIn(['body', 'footer_html']) || '';
};
const checkDefaultFooterModule = (module, action) => {
  const linkType = module.getIn(['body', 'unsubscribe_link_type']);
  const isNotPreferencesLink = linkType !== PREFERENCES_LINK_TYPE;
  const unsubscribeAction = module.getIn(['body', 'unsubscribe_action']);
  const effectiveAction = unsubscribeAction === undefined ? UNSUBSCRIBE_ACTION_ALL : unsubscribeAction;
  return isNotPreferencesLink && effectiveAction === action;
};
const checkButtonModule = (module, action) => {
  const isUnsubscribeButton = module.getIn(['body', 'link_to']) === SUBSCRIPTION_LINK_TO && module.getIn(['body', 'subscription_type']) === BUTTON_SUBSCRIPTION_TYPE_UNSUBSCRIBE;
  if (!isUnsubscribeButton) {
    return false;
  }
  return module.getIn(['body', 'unsubscribe_action']) === action;
};
const checkRichTextModule = (module, token) => {
  return getModuleHtmlContent(module).includes(token);
};
export const checkModuleForUnsubscribeType = (modules, action) => {
  const token = action === UNSUBSCRIBE_ACTION_SPECIFIC ? UNSUBSCRIBE_LINK_TOKEN_SPECIFIC : UNSUBSCRIBE_LINK_TOKEN_ALL;
  return modules.some(module => {
    const isDefaultFooter = getIsFooterModule(module) && module.getIn(['body', 'display']) === FOOTER_TYPE_DEFAULT;
    if (isDefaultFooter) {
      return checkDefaultFooterModule(module, action);
    }
    if (getIsButtonModule(module)) {
      return checkButtonModule(module, action);
    }
    return checkRichTextModule(module, token);
  });
};